function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.6,44.9l-0.2,39.7h7.1c1,4.4,4.9,7.8,9.7,7.8s8.7-3.3,9.7-7.8h8.8    c1,4.4,4.9,7.8,9.7,7.8c4.8,0,8.7-3.3,9.7-7.8h5.8V68.2L97.3,51H80.2v-6.1H46.6L46.6,44.9z M91.5,76.9c3.1,0,5.7,2.5,5.7,5.7    c0,3.1-2.6,5.7-5.7,5.7c-3.1,0-5.7-2.5-5.7-5.7S88.4,76.9,91.5,76.9z M80.2,55.2h14.7l7.9,14.2v11.1h-1.6c-1-4.4-4.9-7.8-9.7-7.8    c-4.8,0-8.7,3.3-9.7,7.8h-1.6C80.2,80.5,80.2,55.2,80.2,55.2z M63.4,76.9c3.1,0,5.7,2.5,5.7,5.7c0,3.1-2.5,5.7-5.7,5.7    c-3.1,0-5.7-2.5-5.7-5.7S60.2,76.8,63.4,76.9z M50.7,80.5l0.1-31.4h25.3v31.4h-3c-1-4.4-4.9-7.8-9.7-7.8s-8.7,3.3-9.7,7.8H50.7    L50.7,80.5z",
  className: "st1_1581759192483",
  vectorEffect: "non-scaling-stroke"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 4.1,
  width: 16.4,
  className: "st1_1581759192483",
  y: 50.1,
  x: 26,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("rect", {
  height: 4.1,
  width: 12.3,
  className: "st1_1581759192483",
  y: 75.5,
  x: 30.1,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("rect", {
  height: 4.1,
  width: 4.4,
  className: "st1_1581759192483",
  y: 75.5,
  x: 21.6,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("rect", {
  height: 4.1,
  width: 22,
  className: "st1_1581759192483",
  y: 62.8,
  x: 16,
  vectorEffect: "non-scaling-stroke"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.2,
    fill: "currentColor",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 141.39999389648438 141.39999389648438",
    xmlSpace: "preserve",
    y: "0px",
    x: "0px"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/ep-truck-transfer.2db93bd6.svg";
export { SvgComponent as ReactComponent };